import React, { useEffect } from "react";
import Storage from "../services/storage.service";
import SimDeactivationOTP from "../views/simDeactivation/sim-deactivation-otp";
import SimDeactivationStepper from "../views/simDeactivation/stepper";

export default function SimDeactivationOTPUI(props) {
	useEffect(() => {

        const stepsDetails = {
            step1: {
                // Number
                // Prepaid & Postpaid
              status: "isDone",
            },
            step2: {
                // OTP
                // Postpaid Only
              status: "inProgress",
            },
            step3: {
                // Absher
                // PrePaid Only
              status: "notVisited",
            },
            step4: {
                // Payment
                // Postpaid Only
              status: "notVisited",
            },
            step5: {
                // Confirmation
                // Prepaid & Postpaid
              status: "notVisited",
            }
        };
        Storage.set("act_step_detail", stepsDetails)
    }, [])
	return (
		<div className="storefront-two-col-pg">
            <div className="sim-deactivation-otp">
                <SimDeactivationOTP {...props}/>
            </div>
			<SimDeactivationStepper />
		</div>
	)
}